(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staradio-article-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var body = document.querySelector('[data-staradio-article-body]');
    if (!body) return;
    body.querySelectorAll('h2').forEach(function(h) {
      if (!h.id) h.id = 'toc-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staradio-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__staradioPdpTabsBound) return;
    window.__staradioPdpTabsBound = true;

    function hashFromHref(href) {
      if (!href) return '';
      var index = String(href).indexOf('#');
      return index === -1 ? '' : String(href).slice(index);
    }

    function isDocumentScroller(el) {
      return el === document.documentElement || el === document.body || el === document.scrollingElement;
    }

    function getScroller() {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) {
        var overflowY = window.getComputedStyle(wrapper).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') return wrapper;
      }
      return document.scrollingElement || document.documentElement;
    }

    function offsetTop() {
      var header = document.getElementById('header-component') || document.querySelector('header-component');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var bar = document.querySelector('.staradio-pdp-tabs-bar');
      var tabsH = bar ? bar.getBoundingClientRect().height : 0;
      return headerH + tabsH + 8;
    }

    function panelFromHash(hash) {
      var id = hashFromHref(hash);
      if (!id || id.length < 2) return null;
      try {
        id = decodeURIComponent(id.slice(1));
      } catch (error) {
        id = id.slice(1);
      }
      return document.getElementById(id);
    }

    function scrollToPanel(target) {
      if (!target) return;
      var extra = offsetTop();
      var scroller = getScroller();
      var nextTop;
      if (isDocumentScroller(scroller)) {
        nextTop = (window.pageYOffset || scroller.scrollTop || 0) + target.getBoundingClientRect().top - extra;
        window.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
        if (scroller.scrollTo) scroller.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
      } else {
        nextTop = scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top - extra;
        scroller.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
      }
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-staradio-tab-link]');
      if (!link) return;
      var target = panelFromHash(link.getAttribute('href') || link.href);
      if (!target) return;
      event.preventDefault();
      scrollToPanel(target);
      document.querySelectorAll('[data-staradio-tab-link]').forEach(function (item) {
        item.classList.toggle('is-active', item === link);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staradio-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('[data-staradio-sticky-atc]');
    if (!bar || window.Shopify?.designMode || window.matchMedia('(min-width: 750px)').matches) return;
    bar.removeAttribute('hidden');
    var atc = document.querySelector('.buy-buttons-block, [data-block-type="buy-buttons"], product-form-component');
    var btn = bar.querySelector('[data-staradio-scroll-to-atc]');
    if (btn && atc) {
      btn.addEventListener('click', function() { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        bar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
      });
    }, { threshold: 0 });
    var target = document.querySelector('.product-information, [data-testid="product-information"]') || document.querySelector('main');
    if (target) observer.observe(target);
  })();

  } catch(e) { console.error(e); }
})();
})();
